import { createSlice } from '@reduxjs/toolkit';

export interface TermsConditionReportState {
    fetching: string;
    reportId: string | null;
    downloadUrl: string | null;
}

const initialState: TermsConditionReportState = {
    fetching: "",
    reportId: null,
    downloadUrl: null,
};

const termsConditionReportSlice = createSlice({
    name: 'termsConditionReport',
    initialState,
    reducers: {
        generateReportRequest: (state) => {
            state.fetching = "requesting";
            state.reportId = null;
            state.downloadUrl = null;
        },
        generateReportPolling: (state, action) => {
            state.fetching = "polling";
            state.reportId = action.payload;
        },
        generateReportReady: (state, action) => {
            state.fetching = "ready";
            state.downloadUrl = action.payload;
        },
        generateReportFailure: (state) => {
            state.fetching = "failed";
        },
        cleanTermsConditionReport: (state) => {
            state.fetching = "";
            state.reportId = null;
            state.downloadUrl = null;
        }
    }
});

export const {
    generateReportRequest,
    generateReportPolling,
    generateReportReady,
    generateReportFailure,
    cleanTermsConditionReport
} = termsConditionReportSlice.actions;

export default termsConditionReportSlice.reducer;
